import type { SpeechGenerateParams } from '../base';
import type { WavespeedSpeechModelConfig } from './types';
import { wavespeedModelConfigs } from './config';
import { extractAudioUrls } from '../tools';
import { translatePromptWithTiming } from '@flowmuse/models/shared/translate';

export function getWavespeedModelConfig(modelId: string): WavespeedSpeechModelConfig {
  const config = wavespeedModelConfigs[modelId];
  if (!config) {
    throw new Error(`Model ${modelId} not found`);
  }
  return config;
}

export async function buildInputPayloadFromConfig(
  modelId: string,
  params: SpeechGenerateParams
): Promise<Record<string, any>> {
  const config = getWavespeedModelConfig(modelId);

  const audioUrls = extractAudioUrls(params.providerOptions);

  // 翻译（与旧实现保持一致：尽力翻译为英文，失败则回退原文）
  let text = params.text;
  if (config.enableTranslation) {
    try {
      const result = await translatePromptWithTiming(params.text, 'en');
      text = result.text;
    } catch {
      text = params.text;
    }
  }

  const payload = await Promise.resolve(
    config.buildInput({
      text,
      voice: params.voice,
      instructions: params.instructions,
      outputFormat: params.outputFormat,
      audioUrls,
      providerOptions: params.providerOptions,
    })
  );

  return payload;
}
